module.exports = __webpack_public_path__ + "static/media/icon_tooltip.16fa0dc9.svg";